// Types
import type { IVDropdownOption } from '~/misc/v-dropdown/types';
import type { TTableHeaders } from '~/misc/v-table/types';
import type {
  TAutomatedEmailSentModeFilter,
  TAutomatedEmailSentTriggerFilter,
} from '~/modules/opportunities/automated-email/sent/composables/use-sent-filters/types';

const TABLE_HEADERS: TTableHeaders = [
  '',
  'Contact name',
  'Trigger',
  'Subject',
  'Sent date',
  'Used functionality',
];

const TRIGGER_DROPDOWN_OPTIONS: IVDropdownOption<
  string,
  TAutomatedEmailSentTriggerFilter | null
>[] = [
  { label: 'All triggers', value: null },
  { label: 'Market success', value: 'market-success' },
  { label: 'Reduced', value: 'reduced' },
  { label: 'Withdrawn', value: 'withdrawn' },
];

const MODE_DROPDOWN_OPTIONS: IVDropdownOption<string, TAutomatedEmailSentModeFilter | null>[] = [
  { label: 'All modes', value: null },
  { label: 'Semi-automatic', value: 'semi-automated' },
  { label: 'Fully automated', value: 'fully-automated' },
];

const CONTACT_NAME_FILTER_DEBOUNCE_IN_MS: number = 500;

export {
  TABLE_HEADERS,
  TRIGGER_DROPDOWN_OPTIONS,
  MODE_DROPDOWN_OPTIONS,
  CONTACT_NAME_FILTER_DEBOUNCE_IN_MS,
};
